module.exports = __webpack_public_path__ + "img/6.b730b209.jpg";